<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      dark
      clipped-left
      v-if="isLogin && !hideAppbar"
    >
      <div class="d-flex align-center" 
        style="cursor: pointer;"
        @click="goPage({ url : 'Dashboard' })">
        <div class="contentCenter">
          <img src="./assets/title_design.png" style="width:120px;" class="ml-auto mr-auto"/>
        </div>
        <v-toolbar-title
          style="font-size:25px; font-weight:bold; color: #000;"
          class="ml-2 mr-auto mt-1"
        >AI智慧影像防護平台</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      <v-menu max-height="600px" offset-y v-if="basciSettingList.length!==0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="menubtn_unactive mr-2"
            id='systemSettingBtn'
            depressed
          >
            基本設定
            <v-icon >mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in basciSettingList"
            :key="index"
            @click="goPage(item)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu max-height="600px" offset-y v-if="eventReportList.length!==0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="menubtn_unactive mr-2"
            id='systemSettingBtn'
            depressed
          >
            發報管理
            <v-icon >mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in eventReportList"
            :key="index"
            @click="goPage(item)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu max-height="600px" offset-y v-if="systemSettingList.length!==0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="menubtn_unactive mr-2"
            id='systemSettingBtn'
            depressed
          >
            系統設定
            <v-icon >mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in systemSettingList"
            :key="index"
            @click="goPage(item)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu max-height="600px" offset-y v-if="systemMaintenanceList.length!==0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="menubtn_unactive mr-2"
            id='systemSettingBtn'
            depressed
          >
            系統維護管理
            <v-icon >mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in systemMaintenanceList"
            :key="index"
            @click="goPage(item)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-divider
        style="height:25px; margin:auto;border-width: 1px; border-color:#8E8E8E !important;"
        class="mr-5"
        vertical inset>
      </v-divider>
      <!-- 用戶名稱 -->
      <div class="mr-5">
        <v-toolbar-title
          class="mt-1"
          style="font-size:20px; font-weight:bold; color: #3C3C3C"
        >{{userName}}</v-toolbar-title>
      </div>
      <!-- 修改密碼 -->
      <div>
        <v-btn
          color="white"
          class="dialogbtn mr-2"
          style="color:#3C3C3C"
          small
          @click="()=>{ dialogPassword = true }"
        >修改密碼</v-btn>
      </div>
      <!-- 登出 -->
      <div>
        <v-btn
          color="white"
          class="dialogbtn"
          style="color:#3C3C3C"
          small
          @click="logout"
        >登出</v-btn>
      </div>
    </v-app-bar>
    
    <v-main class="loginBackground" style="background-color:#C4E1FF">
      <!-- 警示提醒條 -->
      <v-alert
        :color="alertType"
        min-height='50'
        dismissible
        class="rounded-lg white--text"
        style='margin-top: 5px; position: fixed; z-index: 999; width: 82%; top: 0; left: 17%;'
        :value="alert"
      >
        <v-icon class="rounded-lg white--text mb-1">{{alertIcon}}</v-icon>
        {{alertMessage}}
      </v-alert>
      <v-alert
        color="primary"
        class="rounded-lg white--text"
        :style="styleWaiting"
        :value="isWaiting"
      >{{msgWaiting}}</v-alert>
      <router-view
        ref="view"
        @setAlert="setAlert"
        @setWaiting="setWaiting"
        @setAppbar="setAppbar"
        :key="$route.path"
        :user="user"
      ></router-view>
    </v-main>

    <!-- 修改密碼 dialog -->
    <v-dialog overlay-opacity="0.2" max-width="800px" v-model="dialogPassword" persistent>
      <v-card>
        <v-card-title class="headline justify-center font-weight-bold">修改密碼</v-card-title>
        <v-card-text>
          <v-form ref="newDeviceForm">
            <div class="rowDiv contentCenter">
              <div style="width:250px">
                <v-text-field
                  label="舊密碼"
                  v-model="dialogParam.OldPassword"
                  class="rounded-lg"
                  type='password'
                  dense
                  outlined
                  hide-details
                  :rules="rules.content"
                ></v-text-field>
              </div>
            </div>
            <div class="rowDiv contentCenter mt-5">
              <div style="width:250px">
                <v-text-field
                  label="密碼"
                  v-model="dialogParam.NewPassword"
                  class="rounded-lg"
                  type='password'
                  dense
                  outlined
                  hide-details
                  :rules="rules.content"
                ></v-text-field>
              </div>
            </div>
            <div class="rowDiv contentCenter mt-5">
              <div style="width:250px">
                <v-text-field
                  label="確認密碼"
                  v-model="dialogParam.NewPassword_test"
                  class="rounded-lg"
                  type='password'
                  dense
                  outlined
                  hide-details
                  :rules="rules.content"
                ></v-text-field>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn class="dialogbtn cancelBtnColor" @click="()=>{ dialogPassword=false }">關閉</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="dialogbtn subBtnColor" @click="setPassword">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import router from './router'
import Service from './service/service'
// import SignalR from './SignalR'
export default {
  name: 'App',
  components: {
  },
  data: () => ({
    drawer: true,
    alertIcon: '',
    alertType: '',
    alertMessage: '',
    alert: false,
    systemSettingList: [],
    systemMaintenanceList: [],
    basciSettingList: [],
    eventReportList: [],
    userName: '',
    unbillingNumber: 0,
    countDown: 0,
    time: 0,
    timer: null,
    styleWaiting: '',
    isWaiting: false,
    msgWaiting: '',
    hideAppbar: false,

    rules: {
      content: [v => !!v || 'Required']
    },

    dialogPassword: false,
    dialogParam: {
      OldPassword: '',
      NewPassword: '',
      NewPassword_test: ''
    }
  }),
  computed: {
    user: {
      get () {
        if (this.$store.getters.getUser !== '') {
          // console.log(this.$store.getters.getUser)
          return JSON.parse(this.$store.getters.getUser)
        } else {
          return null
        }
      },
      set () {}
    },
    isLogin: {
      get () {
        return this.$store.state.isLogin
      },
      set () {}
    }
  },
  watch: {
    user () {
      if (this.user) {
        this.userName = this.user.userName
        this.getNavbar()
        // SignalR.init(this.user.userId)
        // SignalR.start()
        // SignalR.on('ReceiveHomePageMessage')
        // SignalR.onreconnected()
      } else {
        this.systemSettingList = []
        this.systemMaintenanceList = []
        this.basciSettingList = []
        this.eventReportList = []
        // SignalR.stop()
      }
    },
    '$store.state.notify' () {
      console.log(this.$store.state.notify)
    }
  },
  beforeDestroy () {
    // SignalR.stop()
  },
  mounted () {
    console.log(process.env.VUE_APP_API_env)
    this.checkLogin()
    if (this.user) {
      this.userName = this.user.userName
      this.getNavbar()
      // SignalR.init(this.user.userId)
      // SignalR.start()
      // SignalR.on('ReceiveHomePageMessage')
      // SignalR.onreconnected()
    }
    // console.log(sessionStorage.getItem('token'))
  },
  created: function () {
    // SignalR.on('ReceiveHomePageMessage')
    // SignalR.onreconnected()
  },
  methods: {
    setAppbar (data) {
      this.hideAppbar = data.isHide
    },
    setWaiting (data) {
      this.styleWaiting = data.msgWaiting == 0
        ? 'margin-top: 5px; position: fixed; z-index: 999; min-width: 20%; top: 30%; margin: auto 30%; text-align: center;'
        : 'margin-top: 5px; position: fixed; z-index: 999; min-width: 20%; top: 80%; margin: auto 30%; text-align: center;'
      this.isWaiting = data.isWaiting
      this.msgWaiting = data.msgWaiting
    },
    setAlert (alert) {
      // console.log(alert)
      this.alertType = alert.alertType
      this.alertMessage = alert.alertMessage
      this.alertIcon = alert.alertIcon
      this.alert = true
      setTimeout(() => {
        this.alert = false
      }, 5000)
    },
    checkLogin () {
      if (!this.isLogin) {
        if (!this.$route.path.includes(process.env.VUE_APP_API_LOGIN)) {
          router.push('/' + process.env.VUE_APP_API_LOGIN).catch()
        }
      }
    },
    
    setPassword () {
      if (this.dialogParam.NewPassword !== this.dialogParam.NewPassword_test) {
        this.setAlert({
          alertType: 'error',
          alertMessage: '新密碼確認失敗'
        });
        return
      }
      if (this.dialogParam.NewPassword === this.dialogParam.OldPassword_test) {
        this.setAlert({
          alertType: 'error',
          alertMessage: '新舊密碼不能相同'
        });
        return
      }
      if (this.dialogParam.NewPassword.length < 2 || this.dialogParam.NewPassword_test.length > 10
        ) {
        this.setAlert({
          alertType: 'error',
          alertMessage: '密碼的長度須為2-10字符'
        });
        return
      }

      Service.setPassword(this.dialogParam)
        .then((response) => {
          if (response.status !== 200 || response.data.status !== 0) {
            this.setAlert({
              alertType: 'error',
              alertMessage: response.data.message
            });
            this.dialogPassword = false
          } else {
            this.setAlert({
              alertType: 'success',
              alertMessage: response.data.message
            });
          }
        })
    },
    logout () {
      this.isLogin = false
      this.user = null
      // this.$store.commit('logout')
      Service.logout()
      // SignalR.stop()
    },
    goPage (item) {
      // console.log(item)
      this.$router.push({ path: '/' + item.url }).catch(error => { console.info(error.message) })
    },
    getNavbar () {
      // clear Permission
      this.$store.commit('setPermission', [])

      Service.getNavbar()
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            var alert = {
              alertType: 'error',
              alertIcon: 'mdi-alert-circle',
              alertMessage: response.data.message
            }
            this.setAlert(alert)
          } else {
            // console.log(response.data)
            response.data.forEach(element => {
              if (element.parentId === 202) {
                this.systemSettingList.push(element)
              // console.log(this.systemSettingList)
              } else if (element.parentId === 203) {
                // 系統維護管理 只有系統人員可以處理
                if (this.user.funcLoader.indexOf('FUNC_MENU_203') >= 0) {
                  this.systemMaintenanceList.push(element)
                } else {
                  console.log('Not 203')
                }
              } else if (element.parentId === 200) {
                this.basciSettingList.push(element)
              } else if (element.parentId === 201) {
                this.eventReportList.push(element)
              }
            })
            
            
            if (this.user.funcLoader.indexOf('FUNC_MENU_203') >= 0) {
              const has_adi = this.systemMaintenanceList.find(o=>o.url == 'all_device_info')
              const has_pi = this.systemMaintenanceList.find(o=>o.url == 'Para_Info')
              if (!has_adi) {
                this.systemMaintenanceList.push({
                  name: '設備匯入作業',
                  url: 'all_device_info'
                })
              }
              if (!has_pi) {
                this.systemMaintenanceList.push({
                  name: '系統參數管理',
                  url: 'Para_Info'
                })
              }
            }

            if (this.user.funcLoader.indexOf('FUNC_MENU_MFI') >= 0) {
              this.systemMaintenanceList.push({
                name: '模型管理',
                url: 'Model_Flow_Info'
              })
            }

            let p = []
            this.basciSettingList.forEach(o=>{ p.push(`/${o.url}`) })
            this.eventReportList.forEach(o=>{ p.push(`/${o.url}`) })
            this.systemSettingList.forEach(o=>{ p.push(`/${o.url}`) })
            this.systemMaintenanceList.forEach(o=>{ p.push(`/${o.url}`) })
            this.$store.commit('setPermission', p)
          }
        })
    },
  }
};
</script>
<style>
.v-icon.outlined {
  border: 1px solid currentColor;
  border-radius:50%;
}
.v-data-table>.v-data-table__wrapper>table>thead>tr>th{
  font-weight:bold;
  font-size:20px;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td{
  font-size:18px;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  color: black;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td>ul>li:before {
  content: attr(data-label);
  padding-right: .5em;
  text-align: left;
  display: block;
  color: #999;
}
/* .v-data-table>.v-data-table__wrapper>table {
  border-spacing: 0 10px;
  border-collapse: separate;
} */
.v-btn:not(.v-btn--round).v-size--large {
  height: 44px;
  min-width: 78px;
  padding: 0 19.5555555556px;
  font-size: 20px;
}
tr.v-data-table__selected {
  background: #00BFA5 !important;
}
tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF;
}
tbody tr:nth-of-type(even) {
  background-color: #EEF7FF;
}
.detailTable tbody tr:nth-of-type(even) {
  background-color: #FFEBEE;
}
.detailTable tbody tr:nth-of-type(odd) {
  background-color: white;
}
.detailTable2 tbody tr:nth-of-type(even) {
  background-color: #e5f9fc;
}
.detailTable tbody tr:nth-of-type(odd) {
  background-color: white;
}
.emergencyTable tbody tr:nth-of-type(even) {
  background-color: #FFEEF2;
}
.emergencyTable tbody tr:nth-of-type(odd) {
  background-color: white;
}
.v-data-table>.v-data-table__wrapper>table>tbody>tr.v-data-table__selected>td>ul>li:before {
  color:black;
}
.v-text-field input {
    font-size: 18px;
    width:50px;
}
.v-textarea textarea {
    font-size: 1.2em;
    line-height: 2.2rem!important;
}
.v-input .v-label {
    font-size: 1.3em;
    font-weight:bold;
}
.v-select__selections {
    align-items: center;
    display: flex;
    flex: 1 1;
    flex-wrap: wrap;
    line-height: 20px;
    max-width: 100%;
    min-width: 0;
    font-size: 1.2em;
}
.centered-input input {
  text-align: center
}
.v-subheader {
    align-items: center;
    display: block;
    height: 48px;
}
.v-data-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    font-size: 1rem;
    padding: 0 8px;
}
.v-select:not(.v-input--is-dirty):not(.v-input--is-focused) .v-text-field__prefix {
    line-height: 20px;
    font-weight: bolder;
    top: 7px;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.v-toolbar__title {
    font-size: 1.75rem;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.v-card__title {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 1.10rem;
    font-weight: bold;
    letter-spacing: 0.0125em;
    line-height: 2rem;
    word-break: break-all;
}
.v-alert__content {
    font-size: 1.3em;
    margin-left: 5px;
}
.short_input {
  width:330px;
}
.v-calendar .v-event {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  line-height: 30px;
  margin-right: -1px;
  z-index: 1;
  border-radius: 4px;
}
.v-calendar .v-btn__content {
  align-items: center;
  color: inherit;
  display: flex;
  flex: 1 0 auto;
  justify-content: inherit;
  line-height: normal;
  position: relative;
  transition: inherit;
  font-size: 20px;
}
.v-pagination__item {
  background: transparent;
  border-radius: 4px;
  font-size: 18px;
  height: 34px;
  margin: 0.3rem;
  min-width: 34px;
  padding: 0 5px;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
  width: auto;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
.autocomplete_list {
  position: absolute;
  z-index: 2;
  overflow: auto;
  min-width: 250px;
  margin: 0;
  padding: 0;
  margin-top: -10px;
  border: 1px solid #eee;
  list-style: none;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.05);
}
.autocomplete_list_items {
  background: #fff;
}
.sections {
  background-color:#E1F5FE !important;
  border:1px #1E88E5 solid !important;
  border-radius: 10px !important;
}
.sections_white {
  background-color:white !important;
  border:1px #1E88E5 solid !important;
  border-radius: 10px !important;
}
.v-messages__message {
  font-size: 15px;
  line-height: 15px;
}
.vue__time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 12em !important;
  height: 2.0em !important;
  padding: .3em .5em;
  font-size: 18px !important;
}
.imageUpload {
  background: white;
}
.imageUpload:hover {
  background: #E1F5FE;
}
.v-text-field--outlined.v-input--is-focused fieldset, .v-text-field--outlined.v-input--has-state fieldset {
    border:2px #1976d2 solid;
}
.v-text-field--outlined.v-input--has-state.error--text:not(.v-input--is-focused) fieldset {
    border:1px red solid;
}
.queryText.v-text-field--outlined.v-input--is-focused fieldset{
    border:2px green solid;
}
.v-treeview-node__root {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding-left: 0px;
  padding-right: 0px;
  position: relative;
}
.dialogbtn {
  font-size: 20px !important;
  font-weight: bold;
}
.menubtn_unactive {
  font-size: 20px !important;
  font-weight: bold;
  background-color: white !important;
  color: #3C3C3C!important;
}
.v-list-item--dense .v-list-item__title, .v-list-item--dense .v-list-item__subtitle, .v-list--dense .v-list-item .v-list-item__title, .v-list--dense .v-list-item .v-list-item__subtitle {
  font-size: 18px;
  line-height: 1.5;
}
.rowDiv {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width:100%
}
.rowDiv_noWarp {
  display: flex;
  flex-direction: row;
  width:100%
}
.v-date-picker-table .v-btn {
  z-index: auto;
  margin: 0;
  font-size: 18px;
}
.mainBtnColor {
  background-color: #005AB5 !important;
}
.subBtnColor {
  background-color: #CAF2D2 !important;
}
.infoBtnColor {
  background-color: #C0D6FA !important;
}
.safeColor {
  background-color: #509D8D !important;
}
.warnColor {
  background-color: #FFB612 !important;
}
.mainColor-light {
  background-color: #C0D6FA !important;
}
.cancelBtnColor {
  background-color: #F2F2F2 !important;
  color: #5A6875 !important;
}
.dangerColor {
  background-color: #D84839 !important;
}
.dialog_td {
  font-size:20px;
  color:black;
  font-weight:bold;
}
.v-list-item {
  min-height: 40px !important;
}
.contentCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pageTitle {
  background-color:#004B97;
  color: white;
  text-align:center
}
.greyTh {
  background-color:#F0F0F0;
}
.sortableThDiv {
  cursor: pointer;
  display: flex;
  flex-direction: row;
}
.sortableThDivText {
  font-weight:bold;
  font-size:20px;
  text-align:start;
}
.tableTD {
  white-space: pre-line;
  word-break: break-all;
}
.tableDivider {
  height:25px;
  margin:auto;
  border-width: 1px;
}
.searchTitle {
  font-weight:bold;
  font-size:20px;
  color:#004B97;
}
.loginBackground {
  background-image: url("assets/bg_login_blue.jpg");
  background-size: 100% 100%;
  background-repeat:no-repeat;
  background-attachment: local;
}
.btn_fontSize {
  font-size: 18px !important;
}
.selectedRow {
  background-color:pink !important;
}
canvas {    
  border: 1px solid #333;
  display: block;
}
#canvas{
  background-color: transparent;
  position: absolute;
  z-index: 4;
  cursor: crosshair;
}
#Scanvas{
  background-color: transparent;
  position: absolute;
  z-index: 2;
  cursor: crosshair;
}
#Mcanvas{
  background-color: transparent;
  position: absolute;
  z-index: 4;
  cursor: crosshair;
}
#Lcanvas{
  background-color: transparent;
  position: absolute;
  z-index: 1;
  cursor: crosshair;
}
#canvasSave{   
  position: absolute;
  z-index: 3;
}
.css_td {
  display: table-cell;
  padding: 4px;
  vertical-align: middle;
}
.btn-c-margin {
  margin: 4px !important;
}
</style>
